import _classCallCheck from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
/**
 * Vega-Lite's singleton logger utility.
 */
var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, privateMap, value) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to set private field on non-instance");
  }
  privateMap.set(receiver, value);
  return value;
};
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, privateMap) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return privateMap.get(receiver);
};
var _level;
import { Debug, Error as ErrorLevel, Info, logger, Warn } from 'vega-util';
import * as message_1 from './message';
export { message_1 as message };
/**
 * Main (default) Vega Logger instance for Vega-Lite.
 */
var main = logger(Warn);
var current = main;
/**
 * Logger tool for checking if the code throws correct warning.
 */
export var LocalLogger = /*#__PURE__*/function () {
  function LocalLogger() {
    _classCallCheck(this, LocalLogger);
    this.warns = [];
    this.infos = [];
    this.debugs = [];
    _level.set(this, Warn);
  }
  return _createClass(LocalLogger, [{
    key: "level",
    value: function level(_) {
      if (_) {
        __classPrivateFieldSet(this, _level, _);
        return this;
      }
      return __classPrivateFieldGet(this, _level);
    }
  }, {
    key: "warn",
    value: function warn() {
      var _this$warns;
      if (__classPrivateFieldGet(this, _level) >= Warn) (_this$warns = this.warns).push.apply(_this$warns, arguments);
      return this;
    }
  }, {
    key: "info",
    value: function info() {
      var _this$infos;
      if (__classPrivateFieldGet(this, _level) >= Info) (_this$infos = this.infos).push.apply(_this$infos, arguments);
      return this;
    }
  }, {
    key: "debug",
    value: function debug() {
      var _this$debugs;
      if (__classPrivateFieldGet(this, _level) >= Debug) (_this$debugs = this.debugs).push.apply(_this$debugs, arguments);
      return this;
    }
  }, {
    key: "error",
    value: function error() {
      if (__classPrivateFieldGet(this, _level) >= ErrorLevel) throw Error.apply(void 0, arguments);
      return this;
    }
  }]);
}();
_level = new WeakMap();
export function wrap(f) {
  return function () {
    current = new LocalLogger();
    f(current);
    reset();
  };
}
/**
 * Set the singleton logger to be a custom logger.
 */
export function set(newLogger) {
  current = newLogger;
  return current;
}
/**
 * Reset the main logger to use the default Vega Logger.
 */
export function reset() {
  current = main;
  return current;
}
export function error() {
  var _current;
  (_current = current).error.apply(_current, arguments);
}
export function warn() {
  var _current2;
  (_current2 = current).warn.apply(_current2, arguments);
}
export function info() {
  var _current3;
  (_current3 = current).info.apply(_current3, arguments);
}
export function debug() {
  var _current4;
  (_current4 = current).debug.apply(_current4, arguments);
}